import React, { Component } from "react";
import Hero from './../../alpineComponents/hero';
import VideoBox from './../../alpineComponents/videoBox';
import TextAndImage from './../../alpineComponents/textAndImage';
import TextOverImage from './../../alpineComponents/textOverImage';
import FullWidthImage from './../../alpineComponents/fullWidthImage';
import TwoColumnImageGrid from './../../alpineComponents/twoColumnImageGrid';
import ThreeSquareImageGrid from './../../alpineComponents/threeSquareImageGrid';
import OversizedSideBySideImages from './../../alpineComponents/oversizedSideBySideImages';
import OversizedSideBySideQuote from './../../alpineComponents/oversizedSideBySideQuote';
import EpicImageGrid from './../../alpineComponents/epicImageGrid';
import  './../../utils/analytics';

export default class extends Component {
  render() {
    return (
		<div>
      <h1 style={{"padding":"80px"}}>Hero</h1>
      <Hero
				subtitle={'Hyperlite'}
				title={'We are wakeboarding'}
				backgroundImage={'images/home-back.jpg'}
				height={'full'} /*full, half,threequarter*/
			/>
      <h1 style={{"padding":"80px"}}>VideoBox</h1>
      <VideoBox
				title={'We are wakeboarding'}
				video={'https://player.vimeo.com/external/231425248.hd.mp4?s=2daf3bdb30e018482a4315f88e780af51cda9ed3&amp;profile_id=174'}
			/>
      <div className="max-width-container">
        <h1 style={{"padding":"80px"}}>TextAndImage</h1>
        <TextAndImage
          ratio={'square'}/*square, rectangle*/
          direction={'left'}/*left, right*/
          image={'images/square.png'}
          title={'Featured Products'}
          description={'this is some text this is some text this is some text this is some text this is some text this is some text this is some text this is some text this is some text this is some text this is some text this is some text this is some text '}
          button={true}/*true, false*/
          buttonText={'Click Me'}
          buttonLink={'/thisisapage'}
        />
      </div>
      <h1 style={{"padding":"80px"}}>ProductList</h1>

      <h1 style={{"padding":"80px"}}>FullWidthImage</h1>
      <FullWidthImage
        image={'/images/square.png'}
      />
      <h1 style={{"padding":"80px"}}>TextOverImage</h1>
      <TextOverImage
        overlayColor={'rgba(0,0,0,.25)'}
        //direction={'right'} /*left, right optional*/
        image={'images/square.png'}
        height={'50vh'}/* 50vh 100vh 25vh */
        textColor={'white'} /*white, black */
        title={'Featured Products'}
        description={'this is some text this is some text this is some text this is some text this is some text this is some text this is some text this is some text this is some text this is some text this is some text this is some text this is some text '}
        button={true} /*true, false*/
        buttonText={'Click Me'}
        buttonLink={'/thisisapage'}
      />

      <div className="max-width-container">
        <h1 style={{"padding":"80px"}}>TwoColumnImageGrid</h1>
        <TwoColumnImageGrid
          ratio={'square'}/*square rectangle */
          imageOne={'images/square.png'}
          imageTwo={'images/square.png'}
        />
      </div>
      <div className="max-width-container">
        <h1 style={{"padding":"80px"}}>ThreeSquareImageGrid</h1>
        <ThreeSquareImageGrid
          imageOne={'images/square.png'}
          imageTwo={'images/square.png'}
          imageThree={'images/square.png'}
        />
      </div>
      <div className="max-width-container">
        <h1 style={{"padding":"80px"}}>OversizedSideBySide</h1>
        <OversizedSideBySideImages
          direction={'left'}/*left, right*/
          imageOne={'images/square.png'}
          imageTwo={'images/square.png'}
        />
      </div>
      <div className="max-width-container">
        <h1 style={{"padding":"80px"}}>OversizedSideBySideQuote</h1>
        <OversizedSideBySideQuote
          direction={'left'}/*left, right*/
          image={'images/square.png'}
          quote={'fucking hell yeah all day erry day'}
          rider={'Tmaur'}
        />
      </div>

      <h1 style={{"padding":"80px"}}>EpicImageGrid</h1>
      <EpicImageGrid
        backgroundColor={'#6ddaee'}/*left, right*/
        taglineColor={'#fff'}
        imageOne={'images/square.png'}
        imageTwo={'images/square.png'}
        imageThree={'images/square.png'}
        imageFour={'images/square.png'}
        tagline={'We Are Wakeboarding'}
      />
		</div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/kitchenSink/index.js